import { PantallaCargando } from '@/components/Cargando';
import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { CheckCircle2, Circle, ArrowRight } from 'lucide-react';

const ITEMS = [
  { key: 'whatsapp_ready', label: 'WhatsApp conectado' },
  { key: 'auto_reply_ready', label: 'IA respondiendo a tus clientes' },
  { key: 'assignment_ready', label: 'Vendedor asignado para recibir leads' },
];

export default function AttendanceStatus() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.get('/tenant/lead-attendance/setup-status').then(r => setStatus(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <PantallaCargando />;

  const allReady = ITEMS.every(item => status?.[item.key]);

  return (
    <div className="max-w-xl" data-testid="attendance-status-page">
      <p className="text-sm text-[#64748B] mb-4">Así está tu atención automática en este momento.</p>

      <div className="bg-white border border-[#E2E8F0] rounded-xl p-5 space-y-3">
        {ITEMS.map(item => {
          const ok = !!status?.[item.key];
          return (
            <div key={item.key} className={`flex items-center gap-3 p-3 rounded-lg border ${ok ? 'bg-emerald-50 border-emerald-200' : 'bg-[#F8FAFC] border-[#E2E8F0]'}`} data-testid={`status-item-${item.key}`}>
              {ok ? <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0" /> : <Circle className="w-5 h-5 text-[#CBD5E1] flex-shrink-0" />}
              <span className={`text-sm ${ok ? 'text-emerald-800 font-medium' : 'text-[#64748B]'}`}>{item.label}</span>
            </div>
          );
        })}
      </div>

      {allReady ? (
        <div className="mt-4 p-4 bg-emerald-50 border border-emerald-200 rounded-lg text-center">
          <p className="text-sm font-semibold text-emerald-800">Todo listo — tu negocio está atendiendo automáticamente</p>
        </div>
      ) : (
        <Button onClick={() => navigate('/tenant/setup')} className="w-full mt-4 bg-[#0F172A] text-white" data-testid="status-fix-btn">
          Terminar configuración <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      )}
    </div>
  );
}
